/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsDimensionValue = {
  /**
   * Rows at the dataset's grain carrying this value inside the window
   */
  count: number;
  /**
   * A non-empty value of the dimension
   */
  value: string;
};

/** @internal */
export const AnalyticsDimensionValue$inboundSchema: z.ZodMiniType<
  AnalyticsDimensionValue,
  unknown
> = z.object({
  count: z.int(),
  value: z.string(),
});

export function analyticsDimensionValueFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsDimensionValue, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsDimensionValue$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsDimensionValue' from JSON`,
  );
}
